import { useEffect } from "react";
import { useStore } from "../../../hooks/useStore";
import { useNavigate, useSearchParams } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { FormLayout } from "../../../containers";

/**
 * Обертка сохранения редиректурла сценария входа в ИС
 */
const RedirectUriSaveDecorator: React.FC = () => {
    const { userStore, externalSystemAuthStore } = useStore();
    const [queryParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        let returnUrl = queryParams.get("returnUrl") ?? "";

        // почему-то используя URLSearchParams напрямую не видит первый параметр.
        var searchParams = (new URL(returnUrl)).searchParams;

        let redirectUri = searchParams.get('redirect_uri') ?? "";

        if (redirectUri && searchParams) {
            externalSystemAuthStore.redirectUri = redirectUri;
            externalSystemAuthStore.redirectParams = searchParams;
        }

        navigate('/')
        
    }, [userStore, externalSystemAuthStore])

    // Отдаем все вложенные роуты.
    return <FormLayout></FormLayout>;
}

/**
 * Название компонента, используемое при отладке.
 */
RedirectUriSaveDecorator.displayName = 'RedirectUriSaveDecorator';

export default observer(RedirectUriSaveDecorator);